import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH_PUBLIC = ConstantList.API_ENPOINT + "/public";

export const getAllHealthCareServicePublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-all-health-care-service");
export const estimateExamTimeForListRoomPublic = (arr) =>
  axios.post(API_PATH_PUBLIC + "/estimate-time-for-room", arr);
export const getAllHealthCareRoomByTypePublic = (type) =>
  axios.get(API_PATH_PUBLIC + "/get-all-health-care-room-by-type/" + type);
// all chuyên khoa
export const getAllSpecialistPublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-all-specialist");

// list phòng theo chuyên khoa
export const getListRoomBySpecialist = (specialistId) =>
  axios.get(API_PATH_PUBLIC + "/get-list-room-by-specialist/" + specialistId);

// list dịch vụ theo phòng
export const getListServiceByRoom = (roomId) =>
  axios.get(API_PATH_PUBLIC + "/get-list-service-by-room/" + roomId);

// list working slot theo ngày, phòng, dịch vụ
export const getListWorkingSlot = (dto) =>
  axios.post(API_PATH_PUBLIC + "/list-by-date", dto);

export const saveBookingExam = (dto) =>
  axios.post(API_PATH_PUBLIC + "/save-or-update-appointment", dto);

export const saveTicketConfirm = (dto) =>
  axios.post(API_PATH_PUBLIC + "/save-or-update-customer-ticket", dto);
//hien thi lich su ket qua cua xet nghiem
export const listLabTestByDate = (dto) =>
  axios.post(API_PATH_PUBLIC + "/list-labtest-by-date", dto);

//hien thi lich su ket qua chan doan hinh anh
export const listRisByDate = (dto) =>
  axios.post(API_PATH_PUBLIC + "/list-ris-by-date", dto);
export const getFileDescription = (fileId) => {
  return axios({
    url: API_PATH_PUBLIC + "/get-file-by-id/" + fileId,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "GET",
    responseType: "blob",
  });
};
// all đối tượng
export const getAllPatientTypeService = () =>
  axios.get(API_PATH_PUBLIC + "/get-all-patient-type-serivce");

export const pagingSpecialist = (dto) =>
  axios.post(API_PATH_PUBLIC + "/search-specialist-by-page", dto);
export const pagingHealthCareRoom = (dto) =>
  axios.post(API_PATH_PUBLIC + "/search-room-by-page", dto);
export const pagingHealthCareService = (dto) =>
  axios.post(API_PATH_PUBLIC + "/search-health-service-by-page", dto);

export const pagingCustomerTicketPublic = (sdt) =>
  axios.post(API_PATH_PUBLIC + "/search-by-page-customer-ticket", sdt);
export const getCustomerTicketByIdPublic = (id) =>
  axios.get(API_PATH_PUBLIC + "/get-customer-ticket-by-id/" + id);
export const saveCustomerTicketublic = (obj) =>
  axios.post(API_PATH_PUBLIC + "/save-or-update-ticket-comment", obj);

export const getPatientAndAllVisit = (code) =>
  axios.get(API_PATH_PUBLIC + "/get-patient-and-all-visit/" + code);

export const getDiagPublicReport = (obj) =>
  axios.post(API_PATH_PUBLIC + "/get-diag-report", obj);

export const getPrintReportGroupBySampleCodePublicId = (obj) =>
  axios.post(
    API_PATH_PUBLIC + "/report/get-print-report-group-by-sample-code-id",
    obj
  );

export const getServiceRequestItemByIdPublic = (searchObject) =>
  axios.post(
    API_PATH_PUBLIC + "/img-study/get-service-request-item-by-list-id",
    searchObject
  );

export const linkGenerateBarcodePatientPublic = (patientCode) =>
  axios.get(API_PATH_PUBLIC + "/generate-barcode/" + patientCode, {
    responseType: "arraybuffer",
  });

export const pagingSystemConfig = (obj) =>
  axios.post(API_PATH_PUBLIC + "/system-config/search-by-page", obj);

export const countingByHourlyPublic = (appointment) =>
  axios.post(API_PATH_PUBLIC + "/appointment/counting-by-hourly", appointment);

export const linkGenerateQrByValuePublic = (value) =>
  axios.post(API_PATH_PUBLIC + "/get-qr-code-by-value", value, {
    responseType: "arraybuffer",
  });

export const pagingAdministrativeUnitPublic = (searchAdministrativeUnit) =>
  axios.post(
    API_PATH_PUBLIC + "/administrative-unit/search-by-dto",
    searchAdministrativeUnit
  );

export const pagingDepartmentPublic = (searchObject) => {
  const url = API_PATH_PUBLIC + "/emr-department/search-by-page";
  return axios.post(url, searchObject);
};

export const pagingServiceGroupPublic = (searchObj) => {
  const url = API_PATH_PUBLIC + "/service-group/search-by-page";
  return axios.post(url, searchObj);
};
export const saveOrUpdateAppointmentByCustomer = (appointment) =>
  axios.post(API_PATH_PUBLIC + "/save-appointment-by-customer", appointment);

export const pagingPatientByCode = (obj) =>
  axios.post(API_PATH_PUBLIC + "/paging-patient-by-code", obj);

export const pagingPatientByPhone = (obj) =>
  axios.post(API_PATH_PUBLIC + "/paging-patient-by-phone", obj);

export const pagingPatientByCodeOrPhone = (obj) =>
  axios.post(API_PATH_PUBLIC + "/paging-patient-by-code-or-phone", obj);
